import React from 'react';

const normalizeCards = (structuredData) => {
    if (Array.isArray(structuredData?.cards)) {
        return structuredData.cards;
    }

    if (Array.isArray(structuredData)) {
        return structuredData;
    }

    if (structuredData && typeof structuredData === 'object') {
        return [structuredData];
    }

    return [];
};

const CardMessage = ({ structuredData }) => {
    const cards = normalizeCards(structuredData);

    return (
        <div className='copilot-chat-message copilot-chat-message--structured assistant'>
            <div className='copilot-chat-card-grid'>
                {cards.map((card, index) => {
                    const metadata = card?.metadata && typeof card.metadata === 'object' ? Object.entries(card.metadata) : [];

                    return (
                        <div className='copilot-chat-card-item' key={`card-${index}`}>
                            {card?.title && <div className='copilot-chat-card-title'>{card.title}</div>}
                            {card?.description && <div className='copilot-chat-card-description'>{card.description}</div>}
                            {metadata.length > 0 ?
                                <div className='copilot-chat-card-meta'>
                                    {metadata.map(([key, value]) => {
                                        return (
                                            <div key={key} className='copilot-chat-card-meta-item'>
                                                <span className='copilot-chat-card-meta-key'>{key}:</span>
                                                <span className='copilot-chat-card-meta-value'> {String(value)}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                                : null}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CardMessage;
